import { Object as FabricObject, ObjectRef } from 'fabric'
import { check } from '@/utils/check'
import { reactive } from 'vue'


/**
 * 元素添加相应式属性
 */
const toRef = (object: FabricObject) => {
  if (object.ref) return object

  const keyArr: (keyof ObjectRef)[] = [
    'id',
    'name',
    'hideOnLayer',
    'originX',
    'originY',
    'top',
    'left',
    'width',
    'height',
    'scaleX',
    'scaleY',
    'flipX',
    'flipY',
    'opacity',
    'angle',
    'skewX',
    'skewY',
    'hoverCursor',
    'moveCursor',
    'padding',
    'borderColor',
    'borderDashArray',
    'cornerColor',
    'cornerStrokeColor',
    'cornerStyle',
    'cornerDashArray',
    'centeredScaling',
    'centeredRotation',
    'fill',
    'fillRule',
    'globalCompositeOperation',
    'backgroundColor',
    'selectionBackgroundColor',
    'stroke',
    'strokeWidth',
    'strokeDashArray',
    'strokeDashOffset',
    'strokeLineCap',
    'strokeLineJoin',
    'strokeMiterLimit',
    'shadow',
    'borderScaleFactor',
    'minScaleLimit',
    'selectable',
    'evented',
    'visible',
    'hasControls',
    'hasBorders',
    'perPixelTargetFind',
    'includeDefaultValues',
    'lockMovementX',
    'lockMovementY',
    'lockRotation',
    'lockScalingX',
    'lockScalingY',
    'lockSkewingX',
    'lockSkewingY',
    'lockScalingFlip',
    'excludeFromExport',
    'objectCaching',
    'noScaleCache',
    'strokeUniform',
    'dirty',
    'paintFirst',
    'activeOn',
    'colorProperties',
    'inverted',
    'absolutePositioned',
  ]

  if (check.isTextObject(object)) {
    keyArr.push(
      'text',
      'charSpacing',
      'lineHeight',
      'fontSize',
      'fontWeight',
      'fontFamily',
      'fontStyle',
      'pathSide',
      'pathAlign',
      'underline',
      'overline',
      'linethrough',
      'textAlign',
      'direction',
    )
  }

  object.ref = reactive({}) as ObjectRef

  keyArr.forEach(<K extends keyof ObjectRef>(key: K) => {
    (object.ref as any)[key] = (object as any)[key]

    Object.defineProperty(object, key, {
      get() {
        return (this.ref as any)[key]
      },
      set(value) {
        if ((this.ref as any)[key] === value) return
        (this.ref as any)[key] = value
      },
    })
  })

  return object
}

export { toRef }
